import React from 'react'

export default () => (
  <>
    <section className="section">
      <div className="page-layout page-layout--2__left-main content">
        <div className="column__left search__no-results--title">
          <div className="section__number">00</div>
          <h4 className="heading--6">No Results!</h4>
        </div>
        <div className="column__main ta--1 search__no-results--container">
          <h3 className="heading--2">Sorry, no results.</h3>
          <p className="search__no-results--text">
            This might be because search filters were applied. Add or remove the
            filters above and try your query again or…
          </p>
          <div className="button__wrapper">
            <a
              href="/search"
              className="button button--6-2"
              onClick={() => {
                window.location.assign(`/search`)
              }}
            >
              Clear filters and search
            </a>
          </div>
          <br />
          <br />
          <br />
        </div>
      </div>
    </section>
  </>
)
